export default __webpack_public_path__ + "static/media/planet.a63017b2.svg";